import { render, staticRenderFns } from "./YaMapMarkers.vue?vue&type=template&id=05c9916a&scoped=true&"
import script from "./YaMapMarkers.vue?vue&type=script&lang=js&"
export * from "./YaMapMarkers.vue?vue&type=script&lang=js&"
import style0 from "./YaMapMarkers.vue?vue&type=style&index=0&id=05c9916a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c9916a",
  null
  
)

export default component.exports